import { RouteObject } from "react-router";

import RouteErrorBoundary from "@/shared/ui/errors/RouteErrorBoundary";

export const NodeDiagramRoutes: RouteObject = {
	path: "nodediagram/*",
	errorElement: <RouteErrorBoundary />,

	children: [],
};
